<template>
  <nav id="control_panel" :class="['w3-animate-left', {'closeMenu': !isControlPanelOpen}]" v-if="isAuthenticated">
    <div class="w3-container w3-row">
      <div id="control_panel_content">
        <div class="w3-center logos">
          <img :src="logo" class="w3-image sherpa">
        </div>
        <div id="items_menu">
          <!--<vue-nice-scrollbar classes="menu-scrollbar" v-bind:speed=100 theme="light">-->
            <div class="scroll-me">
              <div v-for="item in currentMenu" :key="item.id" :class="[item.id]">
                <!-- internal link -->
                <router-link v-if="item.contextPath"
                  :to="{ path: item.parentContextPath + item.contextPath }"
                  v-tooltip.right="{content: item.name, delay: { show: 400, hide: 100 }}"
                >
                  <div class="item-menu">
                    <div v-if="!item.icon">
                      <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
                      <span> {{item.name}} </span>
                    </div>
                    <div v-else class="material-icons-outlined">{{ item.icon }}</div>
                  </div>
                </router-link>

                <!-- external link -->
                <a v-else-if="item.externalUrl"
                  :href="item.externalUrl"
                  target="_blank"
                  :id="item.id"
                  v-tooltip.right="{content: item.name, delay: { show: 400, hide: 100 }}"
                >
                  <div class="item-menu">
                    <div v-if="!item.icon">
                      <i :class="['sherpa-icon', 'icon-'+item.id]"></i>
                      <span> {{item.name}} </span>
                    </div>
                    <div v-else class="material-icons-outlined">{{ item.icon }}</div>
                  </div>
                </a>
              </div>
            </div>
          <!--</vue-nice-scrollbar>-->
        </div>
        <div id="dades_usuari">
          <a v-if="helpLink !== ''" :href="helpLink" target="_blank"><i class="sherpa-icon icon-question"></i></a>
          <i v-on:click="logout" class="sherpa-icon icon-logout" v-tooltip.right="{content: $ml.get('closeSession'), delay: { show: 400, hide: 100 }}"></i>
          <div class="remaining-time">{{ remaining }}</div>
        </div>
      </div>
      <div id="control_panel_control">
        <i id="toggle_control_panel" class="fa fa-angle-left" v-on:click="toggleControlPanel()"></i>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import * as controlPanelTypes from '@/store/actions/controlPanel'
export default {
  name: 'app-menu',
  components: {
  },
  data () {
    return {
      currentMenu: [],
      showTooltip: false,
      remaining: ''
    }
  },
  mounted () {
    this.updateRemaining() // primer cálculo inmediato
    this.interval = setInterval(() => {
      this.updateRemaining()
    }, 1000)
  },
  beforeUnmount () {
    clearInterval(this.interval)
  },
  methods: {
    toggleControlPanel (action) {
      this.$store.dispatch(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}/${controlPanelTypes.CONTROL_PANEL_TOGGLE}`)
    },
    logout () {
      document.body.style.transition = 'none'
      document.body.style.opacity = '0'
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, {removeToken: true}).then(() => {
        this.$router.push('/login').catch(() => {})
      })
    },
    updateRemaining () {
      const expiration = localStorage.getItem('sessionExpiration')

      if (!expiration) {
        this.remaining = ''
        this.logout()
        return
      }

      const diff = parseInt(expiration) - Date.now()

      if (diff <= 0) {
        this.remaining = '0h 0m 0s'
        this.logout()
        return
      }

      // convertir milisegundos → horas, minutos, segundos
      const totalSeconds = Math.floor(diff / 1000)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      this.remaining = `${hours}h ${minutes}m ${seconds}s`
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    ...mapGetters(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}`, [`${controlPanelTypes.CONTROL_PANEL_IS_OPEN}`]),
    menu () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`]
    },
    helpLink () {
      return process.env.APP_HELP_LINK
    },
    logo () {
      return process.env.CONTEXT_PATH + 'static/logo.png'
    }
  },
  watch: {
    menu: function (menu) {
      this.currentMenu = menu
    }
  }
}
</script>

<!-- scroll bar -->
<style>
/*The Wrapper*/
.menu-scrollbar {
  max-height: 770px;
}
/*The Content*/
/* .scroll-me{
} */
</style>

<style lang="scss">
.scroll-me {
  > div {
    position: relative;
  }
}
#control_panel {
  width: 300px;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: 1;
  overflow: initial;
  transition: width 0.5s;
  background-color: #f9f9f9;

  >.w3-container {
    width: auto;
    height: 100%;
    margin: 0;
    padding: 0;

    #control_panel_content {
      position: absolute;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      transition: width 0.5s;
      border-right: 1px dotted #bbb;

      .logos {
        padding: 0 10px;

        .mountdata {
          transition: all 0.3s;
          width: 120px;
          margin-top: 20px
        }

        .sherpa {
          transition: all 0.3s;
          width: 85px;
          margin-top: 20px
        }

        .mountdata {
          display: none;
        }
      }

      #items_menu {
        margin-top: 20px;

        a {
          text-decoration: none;
          color: #000;

          .item-menu {
            width: 80px;
            margin: 0;
            transition: all 0.3s;
            text-align: center;
            padding: 10px 0 5px;
            margin: 0 10px;

            i {
              color: #000;
              font-size: 2em;
              vertical-align: middle;
            }

            span {
              margin-left: 30px;
              font-family: 'Noto Sans';
              font-size: 20px;
              font-weight: 400;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              color: #000;
              text-transform: capitalize;
              vertical-align: text-bottom;
              transition: all 0.3s;
              position: absolute;
              margin-top: 11px;
            }

            .material-icons-round,
            .material-icons-outlined {
              font-size: 30px;
              color: #333;
            }
          }
        }

        a.link-active,
        a:hover {
          color: #fff;

          .item-menu {
            background-color: #d42e12;

            i,
            span,
            div {
              color: #fff;
            }
          }
        }
      }

      .menu_tancat {
        display: none;
        position: relative;
        width: 100px;
        height: 100px;

        a {
          position: absolute;
          width: 100%;
          height: 100%;
          padding: 30px;
          color: white;
          transition: all 0.3s;

          i {
            font-size: 2.7em;
          }
        }

        a.link-active,
        a:hover {
          background-color: #5FADBC;
        }
      }
    }

    #control_panel_control {
      display: none;
      position: absolute;
      top: 50%;
      right: -5px;
      transition: all 0.5s;

      i {
        position: absolute;
        font-size: 2em;
        left: 10px;
        bottom: 48%;
        cursor: pointer;
        color: #d42e12;
      }
    }
  }

  &.closeMenu{
    width: 100px;
    position: fixed !important;

    #control_panel_content {
      .logos {
        .mountdata {
          opacity: 0;
        }
        .sherpa {
          margin-top: 8px;
          border: 1px solid #e8e8e8;
        }
      }
      #items_menu {
        a {
          .item-menu {
            span {
              display: none;
              opacity: 0;
              max-width: 0;
            }
          }
        }
      }
    }

    #control_panel_control {
      transform: rotateY(180deg);
      right: -42px;
    }
  }

  #dades_usuari {
    position: absolute;
    bottom: 5px;
    width: 100%;
    text-align: center;

    i {
      color: #d42e12;
      font-size: 32px;
      cursor: pointer;
      font-weight: 900;
      display: block;

      &.icon-question,
      &.icon-segmento {
        font-size: 20px;
        color:#d42e12;
        margin-bottom: 3px;
      }

      &.icon-segmento {
        margin-bottom: 15px;
      }

      &:hover {
        opacity: 0.70;
      }
    }

    .remaining-time {
      font-family: 'Noto Sans';
      color: #d42e12;
      font-size: 12px;
      opacity: 0.90;
    }
  }
}

#control_panel.active {
  width: 100px;
  transition: width 0.5s;
}

#control_panel .tooltip {
  display: none !important;
  transform: initial !important;
  top: 22px !important;
  left: 100px !important;
  white-space: nowrap;
  z-index: 10000000;
  position: absolute;
}
#control_panel #dades_usuari .tooltip {
  top: 4px !important;
}
#control_panel.closeMenu .tooltip {
  display: block !important;
}
</style>
